import Box from '@mui/material/Box';
import { useState } from 'react';

import type { DcrAttachment } from '../../_types/attachment';
import { AttachmentThumbnail } from '../AttachmentThumbnail/AttachmentThumbnail';
import { AttachmentViewer } from '../AttachmentViewer/AttachmentViewer';

import { attachmentListStyles as sx } from './AttachmentList.styles';

type Props = {
	attachments: DcrAttachment[];
};

export const AttachmentList = ({ attachments }: Props) => {
	const [viewerIndex, setViewerIndex] = useState<number | null>(null);

	if (attachments.length === 0) return null;

	const handleClick = (att: DcrAttachment) => {
		const idx = attachments.findIndex(a => a.id === att.id);
		if (idx >= 0) setViewerIndex(idx);
	};

	return (
		<>
			<Box sx={sx.root}>
				{attachments.map(att => (
					<AttachmentThumbnail
						key={att.id}
						attachment={att}
						onClick={handleClick}
					/>
				))}
			</Box>

			{viewerIndex !== null && (
				<AttachmentViewer
					attachments={attachments}
					initialIndex={viewerIndex}
					onClose={() => setViewerIndex(null)}
				/>
			)}
		</>
	);
};
